<template lang="pug">
v-app-bar.accent
  v-btn(v-on:click="$router.go(-1)", icon)
    v-icon mdi-chevron-left
  v-toolbar-title Find your ideal car
  v-spacer
  
  v-btn.mx-2.accent(text, v-on:click="login", v-if="!$user.email")
    v-icon mdi-login
    span Log in
  v-btn.primary(v-on:click="signup", v-if="!$user.email")
    v-icon mdi-account-plus
    span Sign Up
  v-btn.accent.mx-2(icon, v-on:click="upload", v-if="$user.email")
    v-icon mdi-upload
  v-btn.accent.mx-2(icon, v-on:click="logout", v-if="$user.email")
    v-icon mdi-logout
  v-btn(icon, v-if="mobile", v-on:click="toggleMap")
    v-icon mdi-map
  v-btn(icon, v-on:click="openSolarForm")
    v-icon $vuetify.icons.solar
  v-dialog(v-model="dialog", max-width="540")
    template(v-slot:activator="{ on }")
      v-btn(icon, v-on="on")
        v-icon mdi-cogs
    v-card
      v-card-title.headline Adjust your settings
      v-card-text
        p The values below were chosen by your EV Dealer but feel free to adjust them to suit your situation.

        v-row(align="baseline", dense)
          v-col(cols=12, lg=9, order-lg=12)
            span Cost of petrol per litre
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.petrolCost",
              type="number",
              dense,
              solo,
              prefix="$"
            )
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.petrolConsumption",
              type="number",
              dense,
              solo
            )
          v-col(cols=12, lg=9)
            span km / litre if you drove a petrol car instead
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.dieselCost",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Cost of diesel per litre
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.dieselConsumption",
              type="number",
              dense,
              solo
            )
          v-col(cols=12, lg=9)
            span km / litre if you drove a diesel car instead
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.RUCperThousand",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Road User Charges in $ per thousand km
        v-row(align="baseline", dense)
          v-col(cols=12, lg=9)
            span Cost per kWh of electricty at home
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.homekWh",
              type="number",
              dense,
              solo,
              prefix="$"
            )
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.publickWh",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Cost per kWh of electricity in public
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.publicPerMinute",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Cost per minute of electricity in public
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.annualMaintenanceICE",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Annual maintenance on your current car
        v-row(align="baseline", dense)
          v-col(cols=12, lg=3, order="last", order-lg="first")
            v-text-field(
              v-model.number="settings.annualMaintenanceEV",
              type="number",
              dense,
              solo,
              prefix="$"
            )
          v-col(cols=12, lg=9)
            span Annual maintenance on an electric car
        v-row(dense, v-if="disclaimer")
          v-col(cols=12)
            .text-h6 Important details and information
            span(v-html="disclaimer")

      v-card-actions
        v-spacer
        v-btn(text, @click="updateSettings", color="green") Close
</template>
<script>
import UserManagement from "../mixins/UserManagement";
import { headerBus } from "../main";
export default {
  mixins: [UserManagement],
  data() {
    return {
      settings: this.$dealer.user_settings,
      disclaimer: this.$dealer.default_settings.disclaimer,
      dialog: false,
    };
  },
  created() {
    headerBus.$on("showSettings",()=>{
      this.dialog = true;
    })
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    toggleMap() {
      headerBus.$emit("toggleMap");
    },
    updateSettings() {
      this.dialog = false;
    },
  },
};
</script>